import { useEffect } from 'react';

const POLL_CADENCE_MS = [3000, 5000, 10000, 15000, 30000];

const useJobParsePolling = ({ status, refetch, jobId }) => {
  useEffect(() => {
    if (!jobId || !refetch) return undefined;
    if (status !== 'queued' && status !== 'running') return undefined;

    let cancelled = false;
    let timeoutId = null;
    let visibilityHandler = null;
    let attempt = 0;

    const scheduleNext = () => {
      if (cancelled) return;
      const delay = POLL_CADENCE_MS[Math.min(attempt, POLL_CADENCE_MS.length - 1)];
      attempt += 1;

      if (document.hidden) {
        visibilityHandler = () => {
          if (!document.hidden) {
            document.removeEventListener('visibilitychange', visibilityHandler);
            visibilityHandler = null;
            scheduleNext();
          }
        };
        document.addEventListener('visibilitychange', visibilityHandler);
        return;
      }

      timeoutId = setTimeout(async () => {
        timeoutId = null;
        if (cancelled) return;
        try {
          await refetch();
        } catch (error) {
          console.error('useJobParsePolling refetch error', error);
        }
        if (cancelled) return;
        scheduleNext();
      }, delay);
    };

    scheduleNext();

    return () => {
      cancelled = true;
      if (timeoutId) clearTimeout(timeoutId);
      if (visibilityHandler) document.removeEventListener('visibilitychange', visibilityHandler);
    };
  }, [status, jobId, refetch]);
};

export default useJobParsePolling;
